import { Plan } from '@aibees/shared/definition';
import { useEffect, useMemo, useState } from 'react';
import { useCurrentSubscriptionApi } from '../../price-and-plan/api/use-current-subscription-api';
import { Provider } from './context';
import { PlanCardContextProps as ContextProps, CreditOptions } from './types';

export const PlanCardProvider = ({
  children,
  plans,
  yearly,
  isPaid,
  config,
  isLoading,
  variant,
  isMostPopular,
}: ContextProps) => {
  const { data } = useCurrentSubscriptionApi();
  const currentPlan = data?.current?.plan;
  const [selectedPlan, setSelectedPlan] = useState<Plan>();

  const nextPlan = data?.next;
  const isUpcoming = !!nextPlan && selectedPlan?.id === nextPlan.plan?.id;

  const options = useMemo<CreditOptions[]>(
    () =>
      plans.map((plan) => ({
        id: plan.id || '',
        value: plan.metadata.request || '0',
        isFree: Boolean(plan.metadata.is_free),
      })),
    [plans]
  );

  useEffect(() => {
    const stillValid =
      selectedPlan && plans.some((p) => p.id === selectedPlan.id);
    if (stillValid) return;

    const currentRequest = currentPlan?.metadata?.request;
    const matched =
      plans.find((p) => p.id === currentPlan?.id) ??
      (currentRequest
        ? plans.find(
            (p) => Number(p.metadata?.request) === Number(currentRequest)
          )
        : undefined);

    setSelectedPlan(matched ?? plans.at(0));
  }, [plans, currentPlan, selectedPlan]);

  const handleSelectPlan = (event: any) => {
    const plan = plans.find((p) => p.id === event.target.value);
    setSelectedPlan(plan);
  };

  return (
    <Provider
      value={{
        yearly,
        isPaid,
        isUsageBased: true,
        handleSelectPlan,
        currentPlan,
        selectedPlan,
        options,
        config,
        isLoading,
        isCompact: variant === 'compact',
        isMostPopular,
        isUpcoming,
      }}
    >
      {children}
    </Provider>
  );
};
